/* global define */
define('bxStrip',[
  'jquery',
  'responsive',

  // side effect includes
  'bxSlider'
], function (
  $,
  responsive
) {
  'use strict';

  var BxStrip = function BxStrip(args, isResponsive) {
    this.$component = args.$component;
    this.$slider = args.$slider;
    this.bxoptions = args.bxoptions;
    if (isResponsive === null || isResponsive === undefined) {
      this.isResponsive = true;
    } else {
      this.isResponsive = isResponsive;
    }

    this.init();
  };

  BxStrip.prototype = {
    searchArgs: [],
    init: function () {
      var self = this;
      if (self.$component.length) {
        self.initSlider();
      }
    },

    initSlider: function () {
      var self = this;
      self.slider = self.$slider.bxSlider(self.sliderArgs());
      self.slider.onSlideBefore = function ($slideElement) {
        setShadow(self.slider);
      };

      // Only add these listeners, if we have a reloadSlider method on the current slider
      if (self.slider.hasOwnProperty('reloadSlider')) {
        $(window).on('breakpoint', function () {
          if (self.isResponsive) {
            self.slider.reloadSlider(self.sliderArgs());
          }
        });

        self.$component.on('handlebarsAppended', function () {
          self.slider.reloadSlider(self.sliderArgs());
        });

        $(document).ready(function () {
          self.slider.reloadSlider(self.sliderArgs());
        });
      }
    },

    sliderArgs: function () {
      var self = this;
      if (self.isResponsive) {
        if (responsive() === 'md') {
          var args;
          // if there's no tablet option, use desktop
          if (self.bxoptions.tablet) {
            args = self.bxoptions.tablet;
          } else {
            args = self.bxoptions.desktop;
          }
        } else if (responsive() === 'sm') {
          var args = self.bxoptions.phone;
        } else {
          var args = self.bxoptions.desktop;
        }

        if (self.$component.parents('.area-onethird').length || self.$component.parents('.area-twothirds').length) {
          var args = self.bxoptions.phone;
        }
      } else {
        args = self.bxoptions;
      }

      if (args != undefined) {
        args.useCSS = false;
      }
      return args;
    }
  };

  return BxStrip;
});

